import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {CrudAction, CrudConfig, ErrorNotification, SuccessNotification} from '@ngx-ivengi/crud';
import {HttpClient} from '@angular/common/http';
import {AuthDevice} from './auth-device.model';
import {Profile} from './profile.model';
import {NotificationService} from '@ngx-ivengi/notification';

@Injectable()
export class ProfileService {

  constructor(
    private config: CrudConfig,
    private http: HttpClient,
    private notificationService: NotificationService
  ) {
  }

  public getBaseUrl(): string {
    return `${this.config.getApiUrl()}/profile`;
  }

  public get(): Observable<Profile> {
    return new Observable((observer) => {
      this.http.get(`${this.getBaseUrl()}`, {observe: 'response'}).map((response: any) => {
        const profile = new Profile;
        profile.fromResponse(response.body);
        response.body = profile;

        return response;
      }).subscribe(
        response => {
          this.notificationService.notify(
            new SuccessNotification()
              .setEntity(<any>Profile)
              .setAction(CrudAction.READ)
              .setHttpCode(response.status)
          );

          observer.next(response.body);
        },
        err => {
          this.notificationService.notify(
            new ErrorNotification()
              .setEntity(<any>Profile)
              .setAction(CrudAction.READ)
              .setHttpCode(err.status)
          );

          observer.error(err);
        }
      );
    });
  }

  public update(profile: Profile): Observable<Object> {
    return new Observable((observer) => {
      this.http.put(`${this.getBaseUrl()}`, profile, {observe: 'response'}).subscribe(
        response => {
          this.notificationService.notify(
            new SuccessNotification()
              .setEntity(<any>Profile)
              .setAction(CrudAction.UPDATE)
              .setHttpCode(response.status)
          );

          observer.next(response.body);
        },
        err => {
          this.notificationService.notify(
            new ErrorNotification()
              .setEntity(<any>Profile)
              .setAction(CrudAction.UPDATE)
              .setHttpCode(err.status)
          );

          observer.next(err);
        }
      );
    });
  }

  public authDevices() {
    return this.http.get(`${this.config.getApiUrl()}/authentication/device`).map((data) => {
      if(data instanceof Array) {
        return data.map((response) => {
          const authDevice = new AuthDevice();
          authDevice.fromResponse(response);
          return authDevice;
        });
      }
      return data;
    });
  }

  public logoutDevice(deviceId) {
    return this.http.post(`${this.config.getApiUrl()}/authentication/logout`, {authDeviceId: deviceId});
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/profile/profile.service.ts